module.exports = __webpack_public_path__ + "66e16f43145112a4868cf772af472a7e.png";